import { BranchIcon as BranchIconDs, Typography } from "@packages/ds";
import styled from "styled-components";

import { Link } from "ds/Button";

export const LearnMoreLink = styled(Link)`
  font-size: 14px;
`;

export const Note = styled.div`
  margin-left: auto;
  font-size: 13px;
  font-weight: 600;
  color: var(--label-granite-color, var(--granite));
`;

export const Wrapper = styled.span`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  line-height: 20px;
  color: var(--section-ebony-light-color, var(--ebony-light));

  @media (min-width: 768px) {
    display: inline-block;
    max-width: 100%;
  }

  &:focus {
    outline: none;
    border: none;
    padding: 0;
    margin: 0;
  }
`;

export const Text = styled.span``;

export const CancelTitleWrapper = styled.div`
  display: inline;
  white-space: normal;
`;

export const PlainText = styled.span`
  font-weight: 400;
`;

export const BranchIcon = styled(BranchIconDs)`
  transform: scaleY(-1);
`;

export const TrimTitle = styled(Typography.BodyText)`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InlineText = styled(Typography.BodyText)`
  display: inline;
`;
